import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, DatePicker, Row, Col} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import BranchInvoiveInboxView from '../../../components/Invoice/showBranchInvoiveInboxView';
import rightAuth from "../../../components/_utils/userRights";

const { RangePicker } = DatePicker
let dateFormat = localStorage.getItem('company-details')?JSON.parse(localStorage.getItem('company-details')).dateFormat:'DD.MM.YYYY';
class AllBranchInvoices extends Component {

  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    bonusAny: '',
    universityId: '',
    universities: [],
    courses: [],
    showInvoiveView: false,
    ShowBranchInvoiveInboxView: false,
    generatedInvoice: {},
    invoiceId: '',
    userBranch: '',
    time: {
      from: null,
      to: null
    },
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})      
      params.time = this.state.time;
      let data = await Request.getGeneratedBranchInvoices({
        ...params,
        regExFilters: [
          'studentName'
        ]
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }

  componentWillMount() {
    this.setState({userBranch: rightAuth.getUserAuth('userBranch')});
  }

  async componentDidMount() {

  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  
  showInvoive = (record) => {
    window.open(record.invoiceUrl, "_blank");
  }

  closeDocument = () => {
    this.setState({showInvoiveView: false});
  }

  sendInvoice = (invoiceId) => {
    this.setState({ShowBranchInvoiveInboxView: true, invoiceId: invoiceId});
  }
  
  closeInvoiceInbox = () => {
    this.setState({ShowBranchInvoiveInboxView: false});
    let $this = this;
    setTimeout(function() {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      } 
    }, 500);
  }
  
  completeInvoice = async (invoiceId) => {
    let x = await Request.completeBranchInvoice({invoiceId: invoiceId})
    if (!x.error) {
      notification.success({
        message: 'Invoice completed successfully'
      });
      let $this = this;
      setTimeout(function() {
        if ($this.table && $this.table.current) {
          $this.table.current.reload();
        } 
      }, 500);
    } else {
      notification.error({
        message: 'Error Saving',
        description: x.msg
      })
    }
  }
  
  numberFormat = (value) => {
    if(!value) {
      return value;
    }
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1]
        }
      }, () => {
        if (date[0] == undefined) {
          if (this.table && this.table.current) {
            this.table.current.reload();
          } 
        }
      }
    )
  }

  onOk = value => {
    if (this.table && this.table.current) {
      this.table.current.reload();
    } 
  }

  render() {    
    const {dispatch} = this.props

    const { total, showInvoiveView, invoiceId, ShowBranchInvoiveInboxView, userBranch } = this.state;
    const columns = [
      {
        title: "View Summary",
        key: "operation",

        width: 130,
        render: (text, record) => (
          <div className={styles.btnWrapper}>
            <React.Fragment>
              {
                record.invoiceStatus == 'Generated' ?
                <Tooltip title="Send invoice to Head Office">
                  <Button
                    loading={false}
                    className={styles.btn}
                    onClick={() => {this.sendInvoice(record._id)}}
                    shape="circle"
                    icon="forward"
                  />
                </Tooltip>
                :null
              } 
              {
                record.invoiceStatus == 'Paid by HO' ?
                <Tooltip title="Mark 'Paid'">
                  <Button
                    loading={false}
                    className={styles.btn}
                    onClick={() => {this.completeInvoice(record._id)}}
                    shape="circle"
                    icon="check"
                  />
                </Tooltip>
                :null
              }              
              <Tooltip title="View Invoice ">
                <Button
                  loading={false}
                  className={styles.btn}
                  onClick={() => {this.showInvoive(record)}}
                  shape="circle"
                  icon="eye"
                />
              </Tooltip>
            </React.Fragment>
          </div>
        ),
      },
      {
        title: 'Invoice',
        key: 'invoiceNumber',
        dataIndex: 'invoiceNumber',
        sorter: true,
        width: 170,
        searchTextName: 'invoiceNumber',
        filterRegex: true,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                  <div><b>Number:-</b> {record.invoiceNumber}</div>
                  <div><b>Status:-</b> {record.invoiceStatus}</div>
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Institute/Course',
        key: 'instituteStudentId',
        dataIndex: 'instituteStudentId',
        filterRegex: true,
        width: 210,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                <div><b>Institute:-</b> {record.universityInstitutionName}</div>
                <div><b>Course:-</b> {record.courseName}</div>
                <div><b>Tution Fee:-</b> {record.currency} {record.tutionFee} </div>    
              </div>
            </React.Fragment>
          </div>
        )
      },
      // {
      //   title: 'Invoice Details',
      //   key: 'invoices',
      //   dataIndex: 'invoices',
      //   filterRegex: true,
      //   width: 210,
      //   render: (text, record) => (
      //     <div className={styles.wrap}>
      //       <React.Fragment>
      //         <div>
      //           <div><b>Student Name:-</b> {record.studentName}</div>
      //           <div><b>Student Mobile:-</b> {record.studentMobile}</div>
      //           <div><b>Student ID:-</b> {record.instituteStudentId}</div>   
      //        </div>
      //       </React.Fragment>
      //     </div>
      //   )
      // },
      {
        title:'Student Name',
        key:"studentName",
        width:110,
        dataIndex:"studentName"
      },
      {
        title:'Student Mobile',
        key:'studentMobile',
        width:110,
        dataIndex:'studentMobile'
      },
      {
        title:'Student ID',
        key:'instituteStudentId',
        width:110,
        dataIndex:'instituteStudentId'
      },
      {
        title: 'Commission Details',
        key: 'commissionGrandTotal',
        filterRegex: true,
        width: 210,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                <div><b>Commission*Rate:- </b> {record.currency} {record.commissionTotal}*{record.conversionRate}</div>
                <div><b>Commission:- </b> {this.numberFormat(record.totalConvertedCommission)}</div>   
                <div><b>Bank Charges/Pending Commission:- </b> {record.bankCharges}/{this.numberFormat(record.totalAfterBankCharges)}</div>   
                <div><b>GST/Total:- </b> {record.gstRate}%/{this.numberFormat(record.totalGST)}</div>   
                <div><b>TDS/Total:- </b> {record.tdsRate}%/{this.numberFormat(record.totalTDS)}</div>   
                <div><b>Total:- </b> {this.numberFormat(record.totalPayable)}</div>         
            </div>
            </React.Fragment>
          </div>
        )
      },
      {
        title: 'Invoice Generation Date',
        key: 'generationDate',
        dataIndex: 'generationDate',
        width: 100,
        render: (text, record) => (
          <div className={styles.wrap}>
            <React.Fragment>
              <div>
                {moment(record.generationDate).format(dateFormat)}
              </div>
            </React.Fragment>
          </div>
        )
      },
      {
          title: 'Created By',
          width: 150,
          key: 'createdByUser',
          render: (text, record) => {
              return (
                  <div>
                      <div >{text ? text.name : ''}</div>
                      <small>{text ? moment(text.time).format('lll') : ''}</small>
                  </div>
              )
          }
      },
    ];

    return (
      <PageHeaderWrapper title={` All Branch Invoices: ${total} `}>
        { 
          ShowBranchInvoiveInboxView ? 
            <BranchInvoiveInboxView invoiceId={invoiceId} onClose={this.closeInvoiceInbox}/>
          :null
        }
        <Card style={{ marginBottom: 10 }}>
          <div>
            <Row>
              <Col span={8}>
                <label>Filter by Date</label>
                <RangePicker
                  showTime={{ format: 'HH:mm' }}
                  format="YYYY-MM-DD HH:mm"
                  placeholder={['Start Date', 'End Date']}
                  onChange={this.chooseRangerPicker}
                  onOk={this.onOk}
                />
              </Col>
            </Row>
          </div>
        </Card>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{scroll: {x: 900}}}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllBranchInvoices
